import React from "react";
import Routes from "./Routes";
import { AccessibilityProvider } from './contexts/AccessibilityContext';
import { MaintenanceProvider } from './contexts/MaintenanceContext';

function App() {
  return (
    <MaintenanceProvider>
      <AccessibilityProvider>
        <Routes />
      </AccessibilityProvider>
    </MaintenanceProvider>
  );
}

export default App;
